// App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Home from './components/home';
import PrivacyPolicy from './components/privacy';
import Account from './components/account';
import './style/App.css';

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <div className="app-container">
          <div className="tabs">
            <Link to="/" className="tab">Home</Link>
            <Link to="/privacy" className="tab">Privacy</Link>
            <Link to="/account" className="tab">Account</Link>
          </div>
          <div className="tab-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/account" element={<Account />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
